import React, { useCallback, useState } from "react";

/* region Imports - Languages */
import { SettingMessages } from "@languages/interfaces";
import useTranslation from "@languages/useTranslation";
/* endregion Imports - Languages */
/* region Imports - Molecules */
import { PageHeader } from "@molecules/index";
import FormChangePassword from "@molecules/FormChangePassword";
import FormDeleteAccount from "@molecules/FormDeleteAccount";
/* endregion Imports - Molecules */
/* region Imports - Organisms */
import EnvironmentSettings from "@organisms/EnvironmentSettings";
/* endregion Imports - Organisms */
/* region Imports - Pages */
import Office from "@pages/Office";
/* endregion Imports - Pages */
/* region Imports - Styles */
import { useAuth } from "@hooks/useAuth";
import * as Styled from "./styles";
/* endregion Imports - Styles */
/* region Imports - Hooks */
/* endregion Imports - Hooks */

const Settings: React.FC = () => {
  /* region Hooks */

  const { t } = useTranslation();
  const { user } = useAuth();
  /* endregion Hooks */
  /* region States */
  const [selectedTab, setSelectedTab] = useState(() => (user.admin ? 0 : 1));

  /* endregion States */
  /* region Functions */
  /*
   * Function to render the correct tab
   */
  const FrenderConfigTab = useCallback(() => {
    switch (selectedTab) {
      case 0:
        return <EnvironmentSettings />;
      case 1:
        return <FormDeleteAccount />;
      case 2:
        return <FormChangePassword onSubmit={() => setSelectedTab(0)} />;
      default:
        return <FormDeleteAccount />;
    }
  }, [selectedTab]);

  /* endregion Functions */

  return (
    <Office showSelectClient={false}>
      <PageHeader
        title={t(SettingMessages.settingTitlePage)}
        url="/"
        noClientSelection
      />
      <Styled.Container>
        <Styled.TabsContainer>
          {user.admin && (
            <Styled.TabButton onClick={() => setSelectedTab(0)}>
              {t(SettingMessages.settingEnvironmentTitle)}
              <Styled.TabIdentifier active={selectedTab === 0} />
            </Styled.TabButton>
          )}
          <Styled.TabButton onClick={() => setSelectedTab(1)}>
            {t(SettingMessages.settingDeleteOptionTitle)}
            <Styled.TabIdentifier active={selectedTab === 1} />
          </Styled.TabButton>
          <Styled.TabButton onClick={() => setSelectedTab(2)}>
            {t(SettingMessages.settingChangePasswordOptionTitle)}
            <Styled.TabIdentifier active={selectedTab === 2} />
          </Styled.TabButton>
        </Styled.TabsContainer>
        {FrenderConfigTab()}
      </Styled.Container>
    </Office>
  );
};

export default Settings;
